import axios from 'axios'
export default function upload(file) {
	let formData = new FormData();
	formData.append('file', file);
	const token = localStorage.getItem('token') || '';
	const config = {
		headers: {
			"Content-Type": "multipart/form-data;boundary=" + new Date().getTime(),
			token
		}
	};
	return new Promise((resolve, reject) => {
		axios.post("/api/common/files/upload?bucket=tmp", formData, config)
			.then(function(res) {
				if (res.status === 200) {
				  if (res.data.code === 200) {
				    resolve(res.data.data);
				  } else {
				    reject(res.data.msg);
				  }
				}
			})
			.catch(function(err) {
				reject(err);
			});
	})
}
